import * as Yup from "yup";

export default Yup.object().shape({
    businessName: Yup.string().required("Please enter a Company name"),
    initialUser: Yup.object().shape({
        password: Yup.string(),
        confirmPassword: Yup.string().oneOf([Yup.ref('password'), null], "Passwords much match")
    })
});